<template>
  <div 
    class="channel-row"
    @click="setActive(channelId)"
    :class="{ 'selected': selected, 'active': active, 'disabled': !enabled }"
  >
    <div class="bg" :style="{ backgroundColor: visualSettings.sidebarItemActiveBackgroundColor }"></div>
    <div class="table">
      <div class="img-col">
        <div class="inner">
          <Avatar :name="name" :image="image" />
          <div v-if="showStatus && active && selected" class="status" :style="{ backgroundColor: visualSettings.sidebarItemActiveBackgroundColor }">
            <div class="bulb"></div>
          </div>
          <div v-if="showStatus && active && !selected" class="status" :style="{ backgroundColor: visualSettings.sidebarBackgroundColor }">
            <div class="hover" :style="{ backgroundColor: visualSettings.sidebarItemActiveBackgroundColor }"></div>
            <div class="bulb"></div>
          </div>
        </div>
      </div>
      <div class="label" v-if="!selected" :style="{ color: visualSettings.sidebarItemLabelColor }">{{name}}</div>
      <div class="label" v-if="selected" :style="{ color: visualSettings.sidebarItemActiveLabelColor }">{{name}}</div>
      <div v-if="you" class="you" :style="{ color: visualSettings.sidebarItemLabelColor }">
        you
      </div>
      <div v-if="sponsor" class="sponsor">
        <VerifiedIcon />
      </div>
      <div v-if="notificationCount" class="notification">
        <div class="bulb">
          {{notificationCount}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import Avatar from '@/components/Avatar';
import VerifiedIcon from '@/components/VerifiedIcon';

export default {
  name: 'ChannelRow',
  components: {
    Avatar,
    VerifiedIcon
  },
  props: [
    'name',
    'active',
    'sponsor',
    'showStatus',
    'image',
    'enabled',
    'channelId',
    'notificationCount',
    'you'
  ],
  computed: {
    selected() {
      return this.channelId === (this.activeChannel || {}).id
    },
    ...mapGetters([
      'visualSettings'
    ]),
    ...mapState([
      'activeChannel'
    ])
  },
  methods: {
    ...mapActions([
      'setActiveChannelById'
    ]),
    setActive(channelId) {
      this.enabled && this.setActiveChannelById(channelId);
    }
  }
}
</script>

<style scoped lang="scss">
.channel-row {
  position: relative;
  // border-radius: 6px;
  font-size: 0;
  cursor: pointer;
  margin: 2px 0;

  .table {
    position: relative;
    display: table;
    width: 100%;
    padding: 3px 10px;
    box-sizing: border-box;
    z-index: 1;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 6px;
    opacity: 0;
    transition: opacity 250ms ease-out;
    background: #FFFFFF;
  }

  .img-col {
    display: table-cell;
    width: 1px;

    > .inner {
      position: relative;
    }

    .status {
      position: absolute;
      right: -2px;
      bottom: -2px;
      border-radius: 50%;
      box-sizing: border-box;
      background: #fff;
      transition: background 250ms ease-out;

      .hover {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        background: #fff;
        opacity: 0;
        transition: opacity 250ms ease-out;
      }

      .bulb {
        position: relative;
        z-index: 1;
        border-radius: 50%;
        margin: 2px;
        width: 8px;
        height: 8px;
        box-sizing: border-box;
        transition: background 250ms ease-out;
      }
    }

  }

  .label {
    display: table-cell;
    font-size: 14.4px;
    padding: 0 0 0 10px;
    width: 99%;
    letter-spacing: 0.08px;
    font-weight: 400;
    vertical-align: middle;
    max-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    opacity: 0.5;
  }

  .sponsor {
    display: table-cell;
    font-size: 14.4px;
    padding: 0 0 0 5px;
    vertical-align: middle;
  }

  .you {
    display: table-cell;
    font-size: 14.4px;
    width: 1px;
    letter-spacing: 0.08px;
    font-weight: 400;
    vertical-align: middle;
    opacity: 0.6;
    padding: 0 0 0 10px;
  }

  .notification {
    display: table-cell;
    vertical-align: middle;
    padding: 0 0 0 10px;

    .bulb {
      min-width: 20px;
      padding: 0 4px;
      height: 20px;
      border-radius: 10px;
      color: #fff;
      background: #ff7676;
      font-size: 11.2px;
      text-align: center;
      line-height: 20px;
      font-weight: bold;
      box-sizing: border-box;
    }
  }

  &:hover {
    
    .bg {
      opacity: 0.25;
    }

    .img-col {

      .status {
        background: #FFFFFF;

        .hover {
          opacity: 0.25;
        }
      }
    }
  }

  &.disabled {
    cursor: default;

    &:hover {
      
      .bg {
        opacity: 0;
      }

      .img-col {

        .status {

          .hover {
            opacity: 0;
          }
        }
      }
    }
  }

  &.selected {
    cursor: default;

    .bg {
      background: #fff;
      opacity: 1;
    }

    .img-col {

      .status {
        background: #fff;
      }
    }

    @media only screen and (max-width: 768px) {
      cursor: pointer;
    }
  }

  &.active {

    .label {
      opacity: 1;
    }

    .img-col {

      .status {

        .bulb {
          background: #2bbd7e;
        }
      }
    }
  }
}
</style>
